module.exports = __webpack_public_path__ + "media/images/front/icons/events-2d4aaf5b62b044c9e6533130a4cad278.png";